// extracted by mini-css-extract-plugin
export default {"title":"title_WrLl_","simple-modal":"simple-modal_PsElp"};